import { DesktopIcon, MobileIcon } from "@radix-ui/react-icons";
import { useTranslation } from "react-i18next";

import { DeviceOption, DeviceThumb, DeviceTrack } from "./PreviewTab.styles";

export type PreviewDevice = "mobile" | "web";

interface IDeviceToggleProps {
  value: PreviewDevice;
  onChange(value: PreviewDevice): void;
}

/** EN-5261: the preview's Mobile / Web switch — two icons with a sliding thumb. */
export function DeviceToggle({ value, onChange }: IDeviceToggleProps) {
  const { t } = useTranslation();
  const options = [
    {
      value: "mobile" as const,
      label: t("surveys_builder_preview_mobile"),
      Icon: MobileIcon,
    },
    {
      value: "web" as const,
      label: t("surveys_builder_preview_web"),
      Icon: DesktopIcon,
    },
  ];

  return (
    <DeviceTrack role="radiogroup">
      <DeviceThumb position={value === "mobile" ? "first" : "second"} />
      {options.map(({ value: option, label, Icon }) => (
        <DeviceOption
          key={option}
          type="button"
          role="radio"
          aria-checked={value === option}
          aria-label={label}
          title={label}
          selected={value === option}
          onClick={() => onChange(option)}
        >
          <Icon width={18} height={18} />
        </DeviceOption>
      ))}
    </DeviceTrack>
  );
}
